export const MODE = {
  KEEP_TASK_WORK_DAYS: 'keepTaskWorkDays',
  KEEP_TASK_LENGTH: 'keepTaskLength',
  CUSTOM: 'custom'
};
